//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReportFormat } from './Enums';

export class RepertoireReportSettings extends ItemBase {  // OBSOLETE - Use only for compatibility
    StudentIDs: string[] = [];
    IncludeRequested: boolean = false;
    IncludeRecommended: boolean = false;
    IncludeInProgress: boolean = false;
    IncludeCompleted: boolean = false;
    IncludeNotes: boolean = false;
    ShowDuration: boolean = false;
    Format: ReportFormat = ReportFormat.PDF;
    Note: string | null = null;

    constructor(initializer?: Partial<RepertoireReportSettings>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireReportSettings";
}
